import React, { useState ,useEffect} from "react";
import BgCheckOut from "../../images/bgcheckOut.png";
import { baseURL } from "../../constants/Api";
import axios from "axios";
import BackButton from "../bars/BackButton";
import ButtonLoader from "../../components/loaders/ButtonLoader";
import { fetchRoomNoAndPhoneNo, setRoomNoAndPhoneNo } from "../../utils/util";
import { useNavigate,useLocation } from "react-router-dom";
import { RoomChangeSubmitButtonClick } from "../../utils/Analytics";

function RoomChange() {
  const location = useLocation();
  const navigate = useNavigate();
  // edite room change
 const [is_edit,setis_edit] = useState(false);
 const roomChangedata = location.state?.roomChangedata ? location.state?.roomChangedata : null;

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const editStatus = queryParams.has('is_edit') && queryParams.get('is_edit') === 'true';
    setis_edit(editStatus);
  }, [location.search]);
 
  const hotelId = localStorage.getItem("hotel-id");
  const reservationId = localStorage.getItem("reservationId");
  const appUserId = localStorage.getItem("appUserId");
  const guestId = localStorage.getItem("guestId");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [comment, setComment] = useState(roomChangedata === null ? " " : roomChangedata);

  const storedData = fetchRoomNoAndPhoneNo();
  const [roomNumber, setRoomNumber] = useState(storedData?.room);
  const [loading, setLoading] = useState(false);
  const [activebutton , setactivebutton] = useState(false);

  const submitExtent = (e) => {
    e.preventDefault();
    if (roomNumber == "") {
      setError("roomValidation");
    } else if (comment.trim() === "") {
      setError("reasonValidation");
    } else {
      RoomChangeSubmitButtonClick();
      extentRequest();
    }
  };

  const handleRoom = (e) => {
    setRoomNumber(e.target.value);
    setError("");
  };

  const handleComment = (e) => {
    setComment(e.target.value);
    setError("");
  };

  const extentRequest = async (param) => {
    let data = JSON.stringify({
      hotelId,
      guestId,
      appUserId,
      reservationId,
      roomNumber,
      comments: comment,
      ...(is_edit === true && {is_edit}),
    });
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${baseURL}/api/roomChangeV21`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    try {
     
      const response = await axios.request(config);
      console.log(response.data.success);
      if (response.data.success) {
        setError("");
        setRoomNumber("");
        setis_edit(false);
        setComment("");
        setLoading(false);
        setRoomNoAndPhoneNo(roomNumber)
        setSuccess(true);
        setTimeout(() => {
          setSuccess(false);
          navigate("../order-history")

        }, 2000);
        
      } else {
        setLoading(false);
        setError(response.data?.message);
      }
    } catch (error) {
      setLoading(false);
      setError("axios");
     
    }
  };


  // already request




  return (
    <div>
      <div>
        <div className="pb-28 relative">
          <div className="absolute left-3 top-3">
            <BackButton />
          </div>
          <img
            className="w-screen sm:h-[230px] h-[117px]"
            src={BgCheckOut}
            alt="bgHotelguide"
          />
          <div className="section-wrap mx-4 mt-6 sm:mt-14">
            <div className="guestName text-left">
              Room Change Request (upgrade)
            </div>
            <form onSubmit={submitExtent} className="flex flex-col">
              <label className="mt-4 text-left text-[#D0D0D0] text-12px font-normal">
                Current Room Number
              </label>
              <input
                className="mt-2 reqInput"
                type="text"
                onChange={handleRoom}
                value={roomNumber}
              />
              <label className="mt-4 text-left text-[#D0D0D0] text-12px font-normal">
                Reason for change / Upgrade
              </label>
              <textarea
                className="mt-2 reqInput"
                type="textarea"
                onChange={handleComment}
                value={comment}
              />
              <button
                disabled={activebutton}
                className={` ${activebutton ? 'bookBtnInactive': 'bookBtn' } mt-10 max-w-[400px] relative`}
              >
                Request
                {loading && <ButtonLoader />}
              </button>
            </form>
          </div>
        </div>
        <div className="mt-10 fixed  bottom-5 left-1/2 -translate-x-1/2">
          {error == "roomValidation" && (
            <div className="w-full flex justify-center">
              <div className="error-doc text-center mt-3">
                Please give the room number..
              </div>
            </div>
          )}
           {error == "reasonValidation" && (
            <div className="w-full flex justify-center">
              <div className="error-doc text-center mt-3">
                Please give the reason for room change..
              </div>
            </div>
          )}
          {activebutton ? ( <div className="w-full flex justify-center">
              <div className="success-doc text-center mt-3">
              Your request has been sent. Please wait for further action
              </div>
            </div>):('')}
         

          {/* commentValidation */}
          {error == "axios" && (
            <div className="w-full flex justify-center">
              <div className="error-doc text-center mt-3">
                Somthing went wrong..
              </div>
            </div>
          )}
          {error != "axios" && error && error != "roomValidation" && error !="reasonValidation" &&(
              <div className="w-full flex justify-center">
                <div className="error-doc text-center mt-3">
                 {error}
                </div>
              </div>
          )}
          {success && (
            <div className="w-full flex justify-center">
              <div className="success-doc text-center mt-3">
                Successfully Requested
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default RoomChange;
